// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubjectBlock_wrapper__8bpdQ","link":"SubjectBlock_link__s_K_Z","childSubjectLink":"SubjectBlock_childSubjectLink__ZGjCp","header":"SubjectBlock_header__qqltF"};